module.exports = __webpack_public_path__ + "static/img/1_02.5af8a420.jpg";